import { useEffect, useState } from "react";
import { Button, Col, Flex, Form, Row, Select, Table } from "antd";

import { GET } from "../../../../providers/useAxiosQuery";
import { apiUrl, role, userData } from "../../../../providers/companyInfo";
import {
	TablePagination,
	TableShowingEntriesV2,
	useTableScrollOnTop,
} from "../../../../providers/CustomTableFilter";

export default function CollapseItemGradeFileApprovedReportDetails(props) {
	const { location, dataDepartments, dataSchoolYear, dataSemester } = props;

	const userdata = userData();

	const [tableFilter, setTableFilter] = useState({
		page: 1,
		page_size: 50,
		search: "",
		sort_field: "fullname",
		sort_order: "asc",
		from: "grade_file_report",
		school_year_id: "",
		semester_id: "",
		department_ids: "",
		quarter: "",
		grade_file_report_status: "Approved",
	});

	const { data: dataSource, refetch: refetchSource } = GET(
		`api/profile?${new URLSearchParams(tableFilter)}`,
		"profile_grade_file_appoved_report_list",
		() => {}
	);

	useEffect(() => {
		refetchSource();

		return () => {};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [tableFilter]);

	const onChangeTable = (pagination, filters, sorter) => {
		setTableFilter((prevState) => ({
			...prevState,
			sort_field: sorter.columnKey,
			sort_order: sorter.order ? sorter.order.replace("end", "") : null,
			page: 1,
		}));
	};

	const onFinish = (values) => {
		console.log("onFinish values: ", values);

		setTableFilter((prevState) => ({
			...prevState,
			department_ids: values.department_ids ? values.department_ids : "",
			school_year_id: values.school_year_id ? values.school_year_id : "",
			semester_id: values.semester_id ? values.semester_id : "",
			quarter: values.quarter ? values.quarter : "",
			status: values.status ? values.status : "",
			page: 1,
		}));
	};

	const handlePrintPdf = () => {
		let data = {
			...tableFilter,
			user_id: userdata.id,
		};
		window.open(
			apiUrl(
				`api/profile_grade_file_report_print?${new URLSearchParams(data)}`
			),
			"_blank"
		);
	};

	useTableScrollOnTop("tbl_grade_file_approved_report", location.pathname);

	return (
		<Row gutter={[20, 20]} id="tbl-grade-file-approved-wrapper">
			<Col xs={24} sm={24} md={24} lg={24}>
				<Form onFinish={onFinish}>
					<Row gutter={[20, 20]}>
						<Col xs={24} sm={24} md={12} lg={6}>
							{role() !== 3 ? (
								<Form.Item name="department_id" noStyle>
									<Select
										placeholder="Department"
										className="w-100"
										size="large"
										allowClear
										showSearch
										filterOption={(input, option) => {
											// console.log("option", option);
											return (
												option.label
													.toLowerCase()
													.indexOf(input.toLowerCase()) >= 0
											);
										}}
										mode="multiple"
										options={dataDepartments.map((item) => {
											return {
												label: item.department_name,
												value: item.id,
											};
										})}
									/>
								</Form.Item>
							) : null}
						</Col>
						<Col xs={24} sm={24} md={6}>
							<Form.Item name="school_year_id" noStyle>
								<Select
									placeholder="School Year"
									className="w-100"
									size="large"
									allowClear
									showSearch
									filterOption={(input, option) => {
										// console.log("option", option);
										return (
											option.label.toLowerCase().indexOf(input.toLowerCase()) >=
											0
										);
									}}
									options={dataSchoolYear.map((item) => ({
										label: `${item.sy_from} - ${item.sy_to}`,
										value: item.id,
									}))}
								/>
							</Form.Item>
						</Col>

						<Col xs={24} sm={24} md={6}>
							<Form.Item name="semester_id" noStyle>
								<Select
									placeholder="Semester"
									className="w-100"
									size="large"
									allowClear
									showSearch
									filterOption={(input, option) => {
										// console.log("option", option);
										return (
											option.label.toLowerCase().indexOf(input.toLowerCase()) >=
											0
										);
									}}
									options={dataSemester.map((item) => ({
										label: item.semester,
										value: item.id,
									}))}
								/>
							</Form.Item>
						</Col>
						<Col xs={24} sm={24} md={6}>
							<Form.Item name="quarter" noStyle>
								<Select
									placeholder="Quarter"
									className="w-100"
									size="large"
									allowClear
									showSearch
									filterOption={(input, option) => {
										// console.log("option", option);
										return (
											option.label.toLowerCase().indexOf(input.toLowerCase()) >=
											0
										);
									}}
									options={[
										{ label: "Midterm", value: "Midterm" },
										{ label: "Finals", value: "Finals" },
									]}
								/>
							</Form.Item>
						</Col>
						<Col xs={24} sm={24} md={24} lg={24}>
							<Flex justify="space-between" align="center">
								<Button className="btn-main-primary" htmlType="submit">
									Submit
								</Button>

								<Button
									className="btn-main-primary"
									onClick={() => handlePrintPdf()}
								>
									Generate Report
								</Button>
							</Flex>
						</Col>
					</Row>
				</Form>
			</Col>

			<Col xs={24} sm={24} md={24} lg={24}>
				<Table
					id="tbl_grade_file_approved_report"
					className="ant-table-default ant-table-striped"
					dataSource={
						dataSource && dataSource.data.data ? dataSource.data.data : []
					}
					rowKey={(record) => record.id}
					pagination={false}
					bordered={false}
					onChange={onChangeTable}
					scroll={{ x: "max-content" }}
					sticky
				>
					<Table.Column
						title="Full Name"
						key="fullname"
						sorter
						dataIndex="fullname"
						width={200}
					/>

					<Table.Column
						title="Department"
						key="departments"
						dataIndex="departments"
						width={150}
						sorter
					/>

					<Table.Column
						title="Subject"
						key="faculty_loads_subject"
						dataIndex="faculty_loads_subject"
						width={120}
						align="center"
						sorter
					/>
				</Table>
			</Col>

			<Col xs={24} sm={24} md={24}>
				<Flex justify="space-between" className="tbl-bottom-filter">
					<div />

					<Flex gap={15}>
						<TableShowingEntriesV2 />
						<TablePagination
							tableFilter={tableFilter}
							setTableFilter={setTableFilter}
							total={dataSource?.data.total}
							showLessItems={true}
							showSizeChanger={false}
							tblIdWrapper="tbl-grade-file-approved-wrapper"
						/>
					</Flex>
				</Flex>
			</Col>
		</Row>
	);
}
